import { render, staticRenderFns } from "./graphSellsComp.vue?vue&type=template&id=823741fa&scoped=true&"
import script from "./graphSellsComp.vue?vue&type=script&lang=js&"
export * from "./graphSellsComp.vue?vue&type=script&lang=js&"
import style0 from "./graphSellsComp.vue?vue&type=style&index=0&id=823741fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823741fa",
  null
  
)

export default component.exports